import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import { SortDir } from '../../utils/tableSort';

interface SortableHeaderProps {
  label: string;
  column: string;
  activeColumn: string;
  direction: SortDir;
  onSort: (column: string) => void;
  align?: 'left' | 'right' | 'center';
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  column,
  activeColumn,
  direction,
  onSort,
  align = 'left',
}) => (
  <TableCell align={align} sortDirection={activeColumn === column ? direction : false}>
    <TableSortLabel
      active={activeColumn === column}
      direction={activeColumn === column ? direction : 'asc'}
      onClick={() => onSort(column)}
    >
      {label}
    </TableSortLabel>
  </TableCell>
);

export default SortableHeader;
